import React from "react";

import { formatCurrency } from "utils";

function PaymentSummary({
  selectedCurrencyType,
  actualAmount,
  discountAmount,
}) {
  return (
    <div className="col-span-4">
      <div className="px-4 py-6 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3">
        <div className="">
          <h1 className="pt-5 font-medium mb-4 px-3">Payment Summary</h1>
        </div>
        <div className="space-y-2 text-sm">
          <div className="p-4 space-y-4 bg-white shadow-sm">
            <p>Print Package</p>
            <hr />
            <p>
              Set up a public limited company quickly and easily in just a few
              days, with your own nominated Company Secretary other than us. You
              will receive digital copies of your registration documents within
              three to five days of the incorporation application being
              approved, so you can start trading whenever you like.
            </p>
          </div>
        </div>
        <div className="px-4 my-4 TotalWrapper">
          <div className="SubTotalWrapper">
            <div className="flex justify-between">
              <p>One time payment</p>
              <p className="font-bold">
                {selectedCurrencyType} {formatCurrency(actualAmount)}
              </p>
            </div>
            {discountAmount ? (
              <div className="Discount">
                <p className="flex justify-between">
                  Discount
                  <span className="ml-2">
                    {selectedCurrencyType}. {formatCurrency(discountAmount)}
                  </span>
                </p>
              </div>
            ) : null}
            <hr className="my-3" />
            <div>
              <p className="flex justify-between font-bold">
                TOTAL:
                <span className="ml-2">
                  {selectedCurrencyType}{" "}
                  {formatCurrency(actualAmount - discountAmount)}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSummary;
